import * as React from "react";
const SwitchOnIcon = () => /* @__PURE__ */ React.createElement("svg", {
  width: 42,
  height: 23,
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "a"
}, /* @__PURE__ */ React.createElement("stop", {
  stopColor: "#FFF",
  stopOpacity: 0.5,
  offset: "0%"
}), /* @__PURE__ */ React.createElement("stop", {
  stopColor: "#E4EAF6",
  stopOpacity: 0.5,
  offset: "100%"
}))), /* @__PURE__ */ React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ React.createElement("rect", {
  width: 40,
  height: 21,
  rx: 10.5,
  transform: "translate(1 1)",
  fill: "#2895F1",
  fillRule: "nonzero"
}), /* @__PURE__ */ React.createElement("rect", {
  stroke: "#E5E5E5",
  strokeWidth: 1.081,
  strokeLinejoin: "round",
  x: 0.541,
  y: 0.541,
  width: 40.919,
  height: 21.919,
  rx: 10.959
}), /* @__PURE__ */ React.createElement("g", {
  fillRule: "nonzero"
}, /* @__PURE__ */ React.createElement("circle", {
  cx: 8.5,
  cy: 8.5,
  r: 8.5,
  fill: "#000",
  transform: "translate(22 3)"
}), /* @__PURE__ */ React.createElement("circle", {
  cx: 8.5,
  cy: 8.5,
  r: 8.5,
  fill: "#FFF",
  transform: "translate(22 3)"
}), /* @__PURE__ */ React.createElement("circle", {
  cx: 8.5,
  cy: 8.5,
  r: 8.5,
  fill: "url(#a)",
  stroke: "#E5E5E5",
  strokeWidth: 1.081,
  transform: "translate(22 3)"
})), /* @__PURE__ */ React.createElement("path", {
  d: "m11.039 14.548-2.917-2.847a.393.393 0 0 1 0-.57l.589-.57a.43.43 0 0 1 .59 0l2.033 1.995 4.532-4.438a.426.426 0 0 1 .59 0l.588.57a.392.392 0 0 1 0 .568l-5.416 5.292a.426.426 0 0 1-.59 0",
  fill: "#FFF",
  fillRule: "nonzero"
})));
export default SwitchOnIcon;
